<h1 data-test="vJQL73Vh">Team cost / {{ teamCost.name }}</h1>

<h2 data-test="PTNyxWhk">Overview summary</h2>

<md-summary
  data-test="JIVAR-7Z"
  [items]="getSummaryItems(teamCost)"
  [showCosts]="showCosts"
  [currencySign]="currencySign"
></md-summary>

<ng-container
  *ngIf="teamCost.scheduleAssignments && teamCost.scheduleAssignments.length > 0"
>
  <h2 data-test="BR_olMca">Schedule</h2>

  <md-schedule-timeline-graph
    data-test="Nk_fOnlQ"
    [scheduleAssignments]="teamCost.scheduleAssignments"
    [scheduleStartLocations]="teamCost.scheduleStartLocations"
  ></md-schedule-timeline-graph>

  <table data-test="QOCBbg7u" class="document__table items-table items-table_light">
    <tr data-test="3FJiWyIX" class="items-table__header items-table__header_fs-9">
      <th data-test="MW2zNA5r">
        <span data-test="8b2RHk2J" class="mr-2">ASSIGNMENT</span>
      </th>
      <th data-test="_g1v317g">
        <span data-test="FsUkNi_c" class="mr-2">START TIME</span>
      </th>
      <th data-test="FZzbp5EC">
        <span data-test="r1_QHSvL" class="mr-2">END TIME</span>
      </th>
      <th data-test="gTagl4Df">
        <span data-test="Rv0paTYO" class="mr-2">DURATION</span>
      </th>
      <th data-test="2KNm96bR">
        <span data-test="76UVaCU6" class="mr-2">START LOCATION</span>
      </th>
    </tr>
    <tr
      data-test="zYDNI5b3"
      class="row-type"
      *ngFor="let assignment of teamCost.scheduleAssignments; index as i"
      [ngClass]="{ 'row-bg': i % 2 === 0 }"
    >
      <td data-test="5qux3kyY">
        <strong data-test="sr2QkLvD">{{ assignment.name }}</strong>
      </td>
      <td data-test="yaEvdxLq">{{ toTimeWithoutDays(assignment.startTime) }}</td>
      <td data-test="ZjKuT2AV">{{ toTimeWithoutDays(assignment.endTime) }}</td>
      <td data-test="EL7BUJxV">
        {{ toTime(assignment.duration / 60) | time : 'HH:mm' : false }}
      </td>
      <td data-test="wDb2cS-U">{{ getAssignmentsStartLocation(assignment) }}</td>
    </tr>
  </table>
</ng-container>

<ng-container *ngIf="teamCost.compositionRoles && teamCost.compositionRoles.length > 0">
  <h2 data-test="1jDRm8Bd">Team composition</h2>

  <table data-test="z8BAmDX7" class="document__table items-table items-table_light">
    <tr data-test="_UxPWMtO" class="items-table__header items-table__header_fs-9">
      <th data-test="GKt8eUeI">role</th>
      <th data-test="DMQzS5uc">start location</th>
      <th data-test="FVLSQmby">hours</th>
      <th data-test="TkCSolvr">hour price</th>
      <th data-test="zVROMNQZ">overtime price</th>
      <th data-test="ujkuHu16">distance price</th>
      <th data-test="_3rqrzWv">distance</th>
      <th data-test="jQidVl_D">billable price</th>
      <th data-test="wKPZUzdQ">quantity</th>
      <th data-test="N9HnV4eq">amount</th>
    </tr>
    <tr
      data-test="Dr4T1Kzj"
      class="row-type"
      *ngFor="let compositionRole of teamCost.compositionRoles; index as i"
    >
      <td data-test="ZJOQ7u2A">
        <b data-test="zseG9XH7">{{ compositionRole.teamCostRole?.name }}</b>
      </td>
      <td data-test="I1fMX6Yo" class="text-nowrap">
        {{ compositionRole?.scheduleStartLocation?.name }}
      </td>
      <td data-test="6yp0RHwS" class="text-nowrap">
        <ng-container
          *ngIf="compositionRole.scheduleStartLocation; else roleZeroBillableHours"
        >
          {{ compositionRole.billableHours | time : 'HH:mm' }}
        </ng-container>
        <ng-template #roleZeroBillableHours>0</ng-template>
      </td>
      <td data-test="myIb3Tbm" class="text-right text-nowrap">
        <span data-test="YrV5gE06" class="text-light">{{ currencySign }}</span>
        {{
          (teamCost.applyHolidayRates
            ? compositionRole.holidayHourPriceBillablePrice
            : compositionRole.sellPricePerHour
          )
            | fromCents
            | companyCurrency
        }}
      </td>
      <td data-test="LLkJig2j" class="text-right text-nowrap">
        <span data-test="R22Cq0c-" class="text-light">{{ currencySign }}</span>
        {{
          (teamCost.applyHolidayRates
            ? compositionRole.holidayOvertimePriceBillablePrice
            : compositionRole.overtimeSellPricePerHour
          )
            | fromCents
            | companyCurrency
        }}
      </td>
      <td data-test="exjAzDwx" class="text-right text-nowrap">
        <span data-test="6TgSRAlA" class="text-light">{{ currencySign }}</span>
        {{
          compositionRole.transportSellPricePerDistanceUnit | fromCents | companyCurrency
        }}
      </td>
      <td data-test="nN5XYmGk" class="text-right text-nowrap">
        {{ compositionRole.transportDistance | companyCurrency : false : 0 }}
        <span data-test="HrOmwsf-" class="text-light">km</span>
      </td>
      <td data-test="v46zCUvn" class="text-right text-nowrap">
        <span data-test="ftX7U-_Z" class="text-light">{{ currencySign }}</span>
        {{ compositionRole.sellPrice | fromCents | companyCurrency }}
      </td>
      <td data-test="e3t9SawH" class="text-right text-nowrap">
        {{ compositionRole.quantity }}
      </td>
      <td data-test="fjqkChwQ" class="text-right text-nowrap pr-2">
        <span data-test="pp2cApVi" class="text-light">{{ currencySign }}</span>
        {{ getCompositionRoleRowTotal(compositionRole) | fromCents | companyCurrency }}
      </td>
    </tr>
  </table>
  <div data-test="iQgTf0NR" class="pr-2 text-right h3">
    Total:
    <span data-test="6H8cskEs" class="text-light">{{ currencySign }}</span>
    {{ teamCost.compositionRolesTotalBillablePrice | fromCents | companyCurrency }}
  </div>
</ng-container>

<md-teamcost-service
  data-test="zusRnDQU"
  [items]="filterTCServicesByType(teamCost.services, ServiceTypes.GeneralService)"
  [title]="ServiceTypeTitles.GeneralServices"
  [total]="teamCost.generalServicesTotal || 0"
  [currencySign]="currencySign"
></md-teamcost-service>

<md-teamcost-service
  data-test="3A97s4yk"
  [items]="filterTCServicesByType(teamCost.services, ServiceTypes.PeopleService)"
  [title]="ServiceTypeTitles.PeopleServices"
  [total]="teamCost.peopleServicesTotal || 0"
  [currencySign]="currencySign"
></md-teamcost-service>

<md-teamcost-task
  data-test="nsxZlsBb"
  [items]="filterTCTasksByType(teamCost.tasks, TaskTypes.GeneralTask)"
  [title]="TaskTypeTitles.GeneralTasks"
  [total]="teamCost.generalTasksTotal || 0"
  [currencySign]="currencySign"
></md-teamcost-task>

<md-teamcost-task
  data-test="kyjdabdc"
  [items]="filterTCTasksByType(teamCost.tasks, TaskTypes.PeopleTask)"
  [title]="TaskTypeTitles.PeopleTasks"
  [total]="teamCost.peopleTasksTotal || 0"
  [currencySign]="currencySign"
></md-teamcost-task>

<ng-container *ngIf="teamCost.materials && teamCost.materials.length > 0">
  <h2 data-test="tc-materials-heading">Materials</h2>
  <table
    data-test="tc-materials-table"
    class="document__table items-table items-table_light"
  >
    <tr class="items-table__header items-table__header_fs-9">
      <th>Name</th>
      <th class="text-right">Qty</th>
      <th class="text-right">Cost price</th>
      <th class="text-right">Billable price</th>
      <th class="text-right">Total cost</th>
      <th class="text-right">Total billable</th>
    </tr>
    <tr
      *ngFor="let row of teamCost.materials; index as i"
      class="row-type"
      [ngClass]="{ 'row-bg': i % 2 === 0 }"
    >
      <td>{{ row.materialName }}</td>
      <td class="text-right">{{ row.qty }}</td>
      <td class="text-right text-nowrap">
        <span class="text-light">{{ currencySign }}</span>
        {{ (row.unitPrice || 0) / 100 | companyCurrency }}
      </td>
      <td class="text-right text-nowrap">
        <span class="text-light">{{ currencySign }}</span>
        {{ (row.billablePrice || 0) / 100 | companyCurrency }}
      </td>
      <td class="text-right text-nowrap">
        <span class="text-light">{{ currencySign }}</span>
        {{ ((row.unitPrice || 0) * (row.qty || 0)) / 100 | companyCurrency }}
      </td>
      <td class="text-right text-nowrap">
        <span class="text-light">{{ currencySign }}</span>
        {{ ((row.billablePrice || 0) * (row.qty || 0)) / 100 | companyCurrency }}
      </td>
    </tr>
  </table>
  <div class="pr-2 text-right h3">
    Total:
    <span class="text-light">{{ currencySign }}</span>
    {{ getMaterialsTotalBillable(teamCost) / 100 | companyCurrency }}
  </div>
</ng-container>

<ng-container *ngIf="teamCost.transports && teamCost.transports.length > 0">
  <h2 data-test="jmCRqvSm">Transport</h2>

  <md-transport
    data-test="Tslty5f9"
    [currencySign]="currencySign"
    [transports]="teamCost.transports"
  ></md-transport>

  <div data-test="WC-i4Tre" class="pr-2 text-right h3">
    Total:
    <span data-test="vRdOUpHL" class="text-light">{{ currencySign }}</span>
    {{ getTransportsTotalBillablePrice(teamCost) | fromCents | companyCurrency }}
  </div>
</ng-container>
